import axios from "axios";
import { generateUrl, getAccessToken, getTenantId } from "../helper";
const auth = axios.create({ baseURL: generateUrl("user_backend") });

auth.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getAccessToken}`;
    const tenantId = getTenantId();
    if (tenantId && tenantId !== "undefined" && tenantId !== "null") {
      config.headers["x-tenant-id"] = tenantId;
    } else {
      delete config.headers["x-tenant-id"]; // ensure it’s not passed at all
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

auth.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default auth;
